<template>
  <el-form ref="form" class="d-my-editor-group-form" :model="formData"
           :class="['readonly-'+readonly]"
           :disabled="readonly"
           :label-width="labelWidth" :cols="cols">
    <el-form-item v-for="(item,index) in editorList" :key="index"
                  :label="item.label" :rules="item.rules||{required:item.required,message:item.error.replace('$1',item.label.replace(/[:：]/,''))}" :prop="item.path"
    >
      <component :is="item.cmpName" :style="{width:item.width||contentWidth}" :ref="item.ref" v-bind="item.attrs" v-on="item.listeners" v-model="formData[item.path]"></component>
    </el-form-item>
  </el-form>
</template>
<script>
import HeTongLeiXing from '@/projectComponents/HeTongLeiXing.vue'
import ChengBenZhongXin from '@/projectComponents/ChengBenZhongXin.vue'
import userOrg from '@/projectComponents/userOrg.vue'
import user from '@/projectComponents/user.vue'

export default {
  name: 'MyEditorGroup',
  components: {HeTongLeiXing, ChengBenZhongXin, userOrg, user},
  model: {
    prop: 'value'
  },
  props: {
    value: {type: Object, default: r => ({})},
    labelWidth: {type: String, default: '80px'},
    contentWidth: {type: String, default: '300px'},
    config: {type: Object, default: r => ({})},
    cols: {type: String, default: '1'},
    readonly: {type: Boolean, default: false}
  },
  computed: {
    editorList() {
      let editorPaths = Object.getFields(this.config).filter(p => p.includes('.editor')).map(p => /(.+\.editor)/img.exec(p)[1]).unique();
      return editorPaths.map(path => {
        let cfg = this.getFieldVal(this.config, path);
        return {
          ...cfg,
          path: path.replace('.editor', '').replace(/\./, '@')
        }
      })
    },
    // formData() {
    //   let dataPaths = this.editorList.map(i => i.path);
    //   let data = dataPaths.reduce((path, pre) => {
    //     pre[path] = this.getFieldVal(this.value, path.replace('@', '.'))
    //     return pre;
    //   }, {});
    //   return data;
    // }
  },
  data() {
    return {formData: {}};
  },
  mounted() {
    this.initConfig(JSON.parse(JSON.stringify(this.value)))
  },

  watch: {
    value: {
      // deep: true,
      handler: function (newVal, oldVal) {
        // if (Object.deepEqual(newVal, oldVal) == false) {
          // this.formData = newVal;
          this.initConfig(newVal)
        // }
      }
    },
    formData: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.setValue(newVal)
      }
    }
  },
  methods: {
    initConfig(value) {
      let dataPaths = this.editorList.map(i => i.path);
      let data = dataPaths.reduce((pre, path) => {
        pre[path] = this.getFieldVal(value, path.replace(/@/, '.'))
        return pre;
      }, {});
      if (Object.deepEqual(this.formData , data) == false) {
        this.formData = data;
      }
    },
    setValue(newVal) {
      let newData = {};
      for (let k in newVal) {
        this.setFieldVal(newData, k.replace(/@/, '.'), newVal[k]);
      }
      this.$emit('input', newData)
    },
    validate(...args) {
      this.$refs.form.validate(...args)
    },
    getRef(name) {
      return this.$refs[name]
    }
  }
}
</script>
<style lang="scss" scoped>
.d-my-editor-group-form {
  &[cols="1"] {
    .el-form-item {
      display: inline-block;
      width: 100%;
    }
  }

  &[cols="2"] {
    .el-form-item {
      display: inline-block;
      width: 50%;
    }
  }

  &[cols="3"] {
    .el-form-item {
      display: inline-block;
      width: 33.3333%;
    }
  }

  &.readonly-true {

  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyEditorGroup.vue